module.exports = __webpack_public_path__ + "static/media/comdlg32_538.d55eb16b.ico";